import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Customer from '../pages/index';
import DefaultLayout from '../../../layouts/default';
import PrivateOutlet from '../../../components/PrivateOutlet';
import { RouteNameEnum } from '../../../enums/routeName';
import CustomerDetail from '../pages/detail';
import EditCustomer from '../pages/edit';
import EditAlumni from '../pages/editAlumni';
import { PermissionEnum } from '../../../enums/permission';

const routes = [
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.customerViewList],
    },
    routeProperties: {
      path: RouteNameEnum.customer.index,
      element: <Customer />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [
        PermissionEnum.code.customerViewDetail,
        PermissionEnum.code.customerViewVoucherList,
        PermissionEnum.code.customerViewNonApp,
        PermissionEnum.code.customerViewPoint,
        PermissionEnum.code.customerViewQuestionnaire,
        PermissionEnum.code.customerViewCreditSummary,
        PermissionEnum.code.customerViewTransaction,
        PermissionEnum.code.customerViewNominee,
        PermissionEnum.code.customerViewPrimary,
        PermissionEnum.code.customerViewActivityLog,
      ],
      redirectUrl: RouteNameEnum.customer.index,
    },
    routeProperties: {
      path: RouteNameEnum.customer.detail,
      element: <CustomerDetail />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.customerEdit],
      redirectUrl: RouteNameEnum.customer.index,
    },
    routeProperties: {
      path: RouteNameEnum.customer.edit,
      element: <EditCustomer />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.customerEdit],
      redirectUrl: RouteNameEnum.customer.index,
    },
    routeProperties: {
      path: RouteNameEnum.customer.editAlumni,
      element: <EditAlumni />,
    },
  },
];

const BaseRoutes: React.FC = () => (
  <Routes>
    <Route element={<DefaultLayout />}>
      { routes.map((route) => (
        <Route
          key={route.routeProperties.path}
          element={<PrivateOutlet {...route.privateProperties} />}
        >
          <Route {...route.routeProperties} />
        </Route>
      ))}
    </Route>
  </Routes>
);

export default BaseRoutes;
